import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { NestApiProvider } from '../nest-api';
import {Observable} from "rxjs";
import { responseArray, Paginate, responseObj } from '../nest-model/nest-model';
import {
  RequestOvertimeReprocessDto
} from "../gd-only/dto/overtime-request.dto";
/*
  Generated class for the AccessManagementProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class OvertimeRequestApiProvider {

  module: string = 'overtime';
  model: string = 'overtimeRequest';

  constructor(
    public http: HttpClient,
    public nestApi: NestApiProvider
  ) {
    console.log('Hello AccessManagementProvider Provider');
  }

  getOvertimeAttendance(formData) {
    const method: string = "POST";
    const model: string = this.model;
    const func: string = "getOvertimeAttendance";
    const params: any = formData;
    const urlParams: any = {};
    const body: any = {};
    const contentType = 'json';

    const url = this.nestApi.urlBuilder(method, model, func, params, urlParams, this.module);
    return this.nestApi.request<Paginate<any>>(method, url, params, urlParams, body, contentType);
  }

  getOvertimeReason() {
    const method: string = "POST";
    const model: string = this.model;
    const func: string = "getOvertimeReason";
    const params: any = {};
    const urlParams: any = {};
    const body: any = {};
    const contentType = 'json';

    const url = this.nestApi.urlBuilder(method, model, func, params, urlParams, this.module);
    return this.nestApi.request<responseArray<any>>(method, url, params, urlParams, body, contentType);
  }

  readOvertimeSetting() {
    const method: string = "POST";
    const model: string = this.model;
    const func: string = "readOvertimeSetting";
    const params: any = {};
    const urlParams: any = {};
    const body: any = {};
    const contentType = 'json';

    const url = this.nestApi.urlBuilder(method, model, func, params, urlParams, this.module);
    return this.nestApi.request<responseArray<any>>(method, url, params, urlParams, body, contentType);
  }

  getRequestDetail(requestNo: string) {
    const method: string = "POST";
    const model: string = this.model;
    const func: string = "getRequestDetail";
    const params: any = { requestNo: requestNo };
    const urlParams: any = {};
    const body: any = {};
    const contentType = 'json';

    const url = this.nestApi.urlBuilder(method, model, func, params, urlParams, this.module);
    return this.nestApi.request<responseArray<any>>(method, url, params, urlParams, body, contentType);
  }

  getOvertimeHistory(formData) {
    const method: string = "POST";
    const model: string = this.model;
    const func: string = "getOvertimeHistory";
    const params: any = {};
    const urlParams: any = formData;
    const body: any = {};
    const contentType = 'json';

    const url = this.nestApi.urlBuilder(method, model, func, params, urlParams, this.module);
    return this.nestApi.request<Paginate<any>>(method, url, params, urlParams, body, contentType);
  }

  approve(formData: Object) {
    const method: string = "POST";
    const model: string = this.model;
    const func: string = "approve";
    const params: any = formData;
    const urlParams: any = {};
    const body: any = {};
    const contentType = 'json';

    const url = this.nestApi.urlBuilder(method, model, func, params, urlParams, this.module);
    return this.nestApi.request<responseObj<any>>(method, url, params, urlParams, body, contentType);
  }

  reject(formData: Object) {
    const method: string = "POST";
    const model: string = this.model;
    const func: string = "reject";
    const params: any = formData;
    const urlParams: any = {};
    const body: any = {};
    const contentType = 'json';

    const url = this.nestApi.urlBuilder(method, model, func, params, urlParams, this.module);
    return this.nestApi.request<responseObj<any>>(method, url, params, urlParams, body, contentType);
  }

  revise(formData: Object) {
    const method: string = "POST";
    const model: string = this.model;
    const func: string = "revise";
    const params: any = formData;
    const urlParams: any = {};
    const body: any = {};
    const contentType = 'json';

    const url = this.nestApi.urlBuilder(method, model, func, params, urlParams, this.module);
    return this.nestApi.request<responseObj<any>>(method, url, params, urlParams, body, contentType);
  }

  cancel(requestNo: string, companyId: any) {
    const method: string = "POST";
    const model: string = this.model;
    const func: string = "cancel";
    const params: any = { requestNo: requestNo, companyId: companyId };
    const urlParams: any = {};
    const body: any = {};
    const contentType = 'json';

    const url = this.nestApi.urlBuilder(method, model, func, params, urlParams, this.module);
    return this.nestApi.request<responseObj<any>>(method, url, params, urlParams, body, contentType);
  }

  deleteDraft(requestNo: string, companyId: any) {
    const method: string = "POST";
    const model: string = this.model;
    const func: string = "deleteDraft";
    const params: any = { requestNo: requestNo, companyId: companyId };
    const urlParams: any = {};
    const body: any = {};
    const contentType = 'json';

    const url = this.nestApi.urlBuilder(method, model, func, params, urlParams, this.module);
    return this.nestApi.request<responseObj<any>>(method, url, params, urlParams, body, contentType);
  }

  saveDraft(formData) {
    const method: string = "POST";
    const model: string = this.model;
    const func: string = "saveDraft";
    const params: any = formData;
    const urlParams: any = {};
    const body: any = {};
    const contentType = 'json';

    const url = this.nestApi.urlBuilder(method, model, func, params, urlParams, this.module);
    return this.nestApi.request<responseArray<any>>(method, url, params, urlParams, body, contentType);
  }

  add(formData) {
    const method: string = "POST";
    const model: string = this.model;
    const func: string = "add";
    const params: any = formData;
    const urlParams: any = {};
    const body: any = {};
    const contentType = 'json';

    const url = this.nestApi.urlBuilder(method, model, func, params, urlParams, this.module);
    return this.nestApi.request<responseArray<any>>(method, url, params, urlParams, body, contentType);
  }

  getApprovalList(requestNo, isSF6) {
    const method: string = "POST";
    const model: string = "requestInbox";
    const func: string = "getApprovalList";
    const params: any = { requestNo: requestNo, isSF6: isSF6 };
    const urlParams: any = {};
    const body: any = {};
    const contentType = 'json';

    const url = this.nestApi.urlBuilder(method, model, func, params, urlParams, this.module);
    return this.nestApi.request<responseObj<any>>(method, url, params, urlParams, body, contentType);
  }

  listOvtSetting() {
    const method: string = "POST";
    const model: string = this.model;
    const func: string = "listOvtSetting";
    const params: any = {};
    const urlParams: any = {};
    const body: any = {};
    const contentType = 'json';

    const url = this.nestApi.urlBuilder(method, model, func, params, urlParams, this.module);
    return this.nestApi.request<responseArray<any>>(method, url, params, urlParams, body, contentType);
  }

  deleteOvtSetting(code: string) {
    const method: string = "POST";
    const model: string = this.model;
    const func: string = "deleteOvtSetting";
    const params: any = { code: code };
    const urlParams: any = {};
    const body: any = {};
    const contentType = 'json';

    const url = this.nestApi.urlBuilder(method, model, func, params, urlParams, this.module);
    return this.nestApi.request<responseArray<any>>(method, url, params, urlParams, body, contentType);
  }

  addOvtSetting(formData: any) {
    const method: string = "POST";
    const model: string = this.model;
    const func: string = "addOvtSetting";
    const params: any = formData;
    const urlParams: any = {};
    const body: any = {};
    const contentType = 'json';

    const url = this.nestApi.urlBuilder(method, model, func, params, urlParams, this.module);
    return this.nestApi.request<responseArray<any>>(method, url, params, urlParams, body, contentType);
  }

  editOvtSetting(formData: any) {
    const method: string = "POST";
    const model: string = this.model;
    const func: string = "editOvtSetting";
    const params: any = formData;
    const urlParams: any = {};
    const body: any = {};
    const contentType = 'json';

    const url = this.nestApi.urlBuilder(method, model, func, params, urlParams, this.module);
    return this.nestApi.request<responseArray<any>>(method, url, params, urlParams, body, contentType);
  }

  getOvertimeBaseOn() {
    const method: string = "GET";
    const model: string = this.model;
    const func: string = "getOvertimeBaseOn";
    const params: any = {};
    const urlParams: any = {};
    const body: any = {};
    const contentType = 'json';

    const url = this.nestApi.urlBuilder(method, model, func, params, urlParams, this.module);
    return this.nestApi.request<responseArray<any>>(method, url, params, urlParams, body, contentType);
  }

  
  public reprocessOvertime(payload: RequestOvertimeReprocessDto): Observable<any> {

    const method: string = 'POST';
    const func: string = 'reprocessOvertime';
    const params: any = payload || {};
    const urlParams: any = {};
    const body: any = {};

    const url = this.nestApi.urlBuilder(method, this.model, func, {}, urlParams, this.module);
    return this.nestApi.request<any>(method, url, params, urlParams, body);
  }

}



// WEBPACK FOOTER //
// ./src/shared/nestjs/overtime/overtime-request-api.ts